module.exports = __webpack_public_path__ + "4de8837b85f7c62f49ac8e11aabfcd1f.svg";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_ops_flow/verify_receipt/icon-credit-card.svg
// module id = 335
// module chunks = 69